export const XS = 0
export const sm = 600
export const md = 960
export const lg = 1280
export const xl = 1920
